import { VirtualizedTableColumnProps } from './VirtualizedTable.interface';

export const calculateGridTemplateColumns = (
  hasCheckbox: boolean,
  hasRowIcons: boolean,
  fitColumns: boolean,
  hasActions: boolean,
  columns: VirtualizedTableColumnProps[],
) => {
  const checkboxWidth = hasCheckbox ? '50px ' : '';
  const iconWidth = hasRowIcons ? '50px ' : '';
  const actionsWidth = hasActions ? ' min-content' : '';

  if (fitColumns) {
    return (
      checkboxWidth +
      iconWidth +
      columns
        .map((_column, _index) => {
          return `1fr`;
        })
        .join(' ') +
      actionsWidth
    );
  }

  return (
    checkboxWidth +
    iconWidth +
    columns
      .map((column, _index) => {
        const width = column.width ? column.width + 'px' : '1fr';
        return `${width}`;
      })
      .join(' ') +
    actionsWidth
  );
};
